/* eslint-disable no-undef */
import { domain } from 'utils/environment';
import Base from './base';

export default class SupercastConnect extends Base {
  attributeConfig = {
    environment: { required: false, default: 'production' },
    "subscription-identifier": { required: false, default: null },
    subdomain: { required: false, default: null }
  }

  async fetchCard() {
    const subdomain = this.subdomain || Supercast.currentSubdomain;
    const url = new URL(`${domain(subdomain, this.environment)}/embeds/connect`);
    const response = await fetch(url, {
      headers: {
        "X-Supercast-Subscription-Identifier": this["subscription-identifier"]
      }
    });
    if (response.ok) {
      const html = await response.text();
      return this.extractCard(html);
    } else {
      const error = await response.text();
      this.showError(error);
    }
  }

  async fetchStyle() {
    const style = await fetch(`${domain('app', this.environment)}/js/embed.css`);
    if (style.ok) {
      const css = await style.text();
      const styleEl = document.createElement('style');
      styleEl.textContent = css;
      return styleEl;
    } else {
      this.showError("Unable to load embed styles");
    }
  }

  extractCard(html) {
    const holderEl = document.createElement('div');
    holderEl.innerHTML = html;
    return holderEl.querySelector('.embed-content');
  }

  attachEvents() {
    // Add the subscription identifier to each player link
    this.rootElement.querySelectorAll('a[data-player-link]').forEach(element => {
      const currentURL = new URL(element.href);
      currentURL.searchParams.set('subscription_identifier', this["subscription-identifier"]);
      element.href = currentURL.toString();
    });
  }
}
